@import '../../../../../constants/spacing.module.less';
@import './new-lineup-plan-grid-shared-styles.module.less';

.new-lineup-plan-grid-card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: @space-16 @space-16 @space-32 @space-16;

  // matches other "cards" in the drawer
  background: var(--light--background-color--1);
  border: solid 1px var(--default--border-color--12);
  border-radius: 8px;
  margin-bottom: @space-24;

  // When merged with tabs and has promotional banner - remove top border but keep radius
  &.merged-with-tabs {
    border-top: none;
    margin-top: 0;
    border-top-left-radius: 0;
  }
}

.annual-toggle {
  justify-content: center;
  margin-bottom: @space-12;

  .annual-segment-label {
    display: inline-flex;
    align-items: center;
    gap: @space-8;
  }

  .savings-badge {
    padding: @space-4 @space-8;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    border: 1px solid var(--grey-800);
    background: var(--grey-100);
    color: var(--grey-800);
  }

  .savings-badge:hover {
    border: 1px solid var(--grey-900);
    color: var(--grey-900);
  }

  // Normalize segment label heights so the indicator fills cleanly on both sides.
  // Without this, the Annual label (taller due to the badge) makes the Monthly
  // indicator shorter than the container, leaving gaps above/below it.
  :global(.mantine-SegmentedControl-label) {
    display: flex;
    align-items: center;
    height: 34px;
  }

  // Mantine sets data-active on the label element of the selected segment
  :global([data-active]) {
    .savings-badge {
      background: var(--grey-800);
      border-color: var(--grey-800);
      color: var(--white);
    }
  }
}

.monthly-switch-error-banner {
  margin-bottom: @space-24;
}

.new-lineup-plan-grid {
  display: grid;
}

.plan-headers {
  display: grid;
  grid-column: 1 / -1;
  grid-auto-flow: column;
  row-gap: @space-16;
  grid-template-columns: subgrid;
  grid-template-areas:
    '@{name-grid-area}'
    '@{description-grid-area}'
    '@{shipment-limit-label-grid-area}'
    '@{shipment-limit-grid-area}'
    '@{user-count-label-grid-area}'
    '@{user-count-grid-area}'
    '@{analytics-license-label-grid-area}'
    '@{analytics-license-grid-area}'
    '@{divider-grid-area}'
    '@{current-price-grid-area}'
    '@{select-plan-button-grid-area}'
    '@{highlights-title-grid-area}'
    '@{highlights-features-grid-area}';
}
